package org.zq.linkgame.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import linkgame_master.composeapp.generated.resources.Res
import linkgame_master.composeapp.generated.resources.noto_sans_sc_regular
import org.jetbrains.compose.resources.Font

/**
 * 应用字体 - 思源黑体
 */
@Composable
fun appFontFamily(): FontFamily {
    return FontFamily(
        Font(Res.font.noto_sans_sc_regular, FontWeight.Normal)
    )
}
